var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Space-Fix-Copy",
    transform: "translate(-170.000000, -248.000000)",
    fill: "#3254C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.333333,256 L176.666667,256 C177.033333,256 177.333333,255.7 177.333333,255.333333 C177.333333,254.966667 177.033333,254.666667 176.666667,254.666667 L175.333333,254.666667 C174.966667,254.666667 174.666667,254.966667 174.666667,255.333333 C174.666667,255.7 174.966667,256 175.333333,256 Z M170,248.666667 C170,249.033333 170.3,249.333333 170.666667,249.333333 L181.333333,249.333333 C181.7,249.333333 182,249.033333 182,248.666667 C182,248.3 181.7,248 181.333333,248 L170.666667,248 C170.3,248 170,248.3 170,248.666667 Z M172.666667,252.666667 L179.333333,252.666667 C179.7,252.666667 180,252.366667 180,252 C180,251.633333 179.7,251.333333 179.333333,251.333333 L172.666667,251.333333 C172.3,251.333333 172,251.633333 172,252 C172,252.366667 172.3,252.666667 172.666667,252.666667 Z",
    id: "Shape-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSelected);
export default __webpack_public_path__ + "static/media/filter_selected.de218435.svg";
export { ForwardRef as ReactComponent };